import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import SchemaOrg from "@/components/base/SchemaOrg";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import PartnershipSection from "./components/PartnershipSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import { faqData } from "@/mocks/faq";

const siteUrl =
  (import.meta.env.VITE_SITE_URL as string) || "https://tbm-beauty-lab.com";

const SITE_IMAGE =
  "https://media.genaiweb.ai/73acebca-6391-4da3-b270-472de16380f3/og-image.jpeg";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${siteUrl}/#organization`,
  name: "株式会社TBM健康美容研究所",
  alternateName: "TBM Health & Beauty Research Institute",
  description:
    "健康・美容トレンドをプロデュースする総合研究所。教材・出版、新製品化、健康事業、サロン経営コンサルティング、スクール・セミナー、総合美容検定、グローバルプロジェクトを展開。",
  url: `${siteUrl}/`,
  logo: SITE_IMAGE,
  image: SITE_IMAGE,
  telephone: "+81-27-310-2220",
  address: {
    "@type": "PostalAddress",
    streetAddress: "栄町13-1",
    addressLocality: "高崎市",
    addressRegion: "群馬県",
    postalCode: "370-0841",
    addressCountry: "JP",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+81-27-310-2220",
    faxNumber: "+81-27-327-6344",
    contactType: "customer service",
  },
  sameAs: ["https://www.chuo.ac.jp/tbm/"],
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${siteUrl}/#organization`,
  name: "株式会社TBM健康美容研究所",
  alternateName: "TBM Health & Beauty Research Institute",
  description:
    "健康・美容トレンドをプロデュースする総合研究所。教材・出版、新製品化、健康事業、サロン経営コンサルティング、スクール・セミナー、総合美容検定、グローバルプロジェクトを展開。",
  url: `${siteUrl}/`,
  logo: SITE_IMAGE,
  image: SITE_IMAGE,
  telephone: "+81-27-310-2220",
  address: {
    "@type": "PostalAddress",
    streetAddress: "栄町13-1",
    addressLocality: "高崎市",
    addressRegion: "群馬県",
    postalCode: "370-0841",
    addressCountry: "JP",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 36.3229,
    longitude: 139.0036,
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+81-27-310-2220",
    faxNumber: "+81-27-327-6344",
    contactType: "customer service",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:00",
      closes: "18:00",
    },
  ],
  foundingDate: "2007",
  parentOrganization: {
    "@type": "Organization",
    name: "中央カレッジグループ",
    url: "https://www.chuo.ac.jp/tbm/",
  },
};

const faqPageSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqData.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer,
    },
  })),
};

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg data={organizationSchema} />
      <SchemaOrg data={localBusinessSchema} />
      <SchemaOrg data={faqPageSchema} />
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <PartnershipSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}